import {
  AMORTIZE_CALCULATE,
  AMORTIZE_CALCULATE_FAILURE,
  AMORTIZE_CALCULATE_SUCCESS,
  AMORTIZE_STATUS,
  AMORTIZE_STATUS_FAILURE,
  AMORTIZE_STATUS_SUCCESS,
  CHANGE_ADJUSTMENT_FILTER,
  CHANGE_INPUT,
  CHANGE_STEP,
  RESET_ALL_CALCULATORS,
  RESET_CALCULATOR,
  RESET_CALCULATOR_RESULTS,
  RESET_FORM_ERROR,
  RESET_STATE,
  RESET_STATUS,
  RESET_STEP,
  SET_IS_SCHEDULE_DRAWER_OPEN,
  SET_IS_SLIDER_FOCUSED,
  UPDATE_FORM_ERROR,
} from './constants';

export function amortizeCalculate({
  amount,
  calculateStatus,
  loanNumber,
  requestBody,
}) {
  return {
    payload: {
      amount,
      calculateStatus,
      loanNumber,
      requestBody,
    },
    type: AMORTIZE_CALCULATE,
  };
}

export function amortizeCalculateFailure(calculateStatus, error) {
  return {
    payload: { calculateStatus, error },
    type: AMORTIZE_CALCULATE_FAILURE,
  };
}

export function amortizeCalculateSuccess({ calculateStatus, currentSetting, payments }) {
  return {
    payload: { calculateStatus, currentSetting, payments },
    type: AMORTIZE_CALCULATE_SUCCESS,
  };
}

export function amortizeStatus({ loanNumber }) {
  return {
    payload: { loanNumber },
    type: AMORTIZE_STATUS,
  };
}

export function amortizeStatusFailure(error) {
  return {
    payload: { error },
    type: AMORTIZE_STATUS_FAILURE,
  };
}

export function amortizeStatusSuccess({
  currentSetting,
  payments,
  prePopulatedAmortizationFields,
}) {
  return {
    payload: {
      currentSetting,
      payments,
      prePopulatedAmortizationFields,
    },
    type: AMORTIZE_STATUS_SUCCESS,
  };
}

export function changeAdjustmentFilter(filter) {
  return {
    payload: { filter },
    type: CHANGE_ADJUSTMENT_FILTER,
  };
}

export function changeInput({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT,
  };
}

export function changeStep({ step }) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function resetAllCalculators() {
  return { type: RESET_ALL_CALCULATORS };
}

export function resetCalculator(form) {
  return {
    payload: { form },
    type: RESET_CALCULATOR,
  };
}

export function resetCalculatorResults(calculateStatus) {
  return {
    payload: { calculateStatus },
    type: RESET_CALCULATOR_RESULTS,
  };
}

export function resetStatus(statusName) {
  return {
    payload: { statusName },
    type: RESET_STATUS,
  };
}

export function resetFormError({ field, form }) {
  return {
    payload: { field, form },
    type: RESET_FORM_ERROR,
  };
}

export function resetState() {
  return { type: RESET_STATE };
}

export function resetStep() {
  return { type: RESET_STEP };
}

export function setIsScheduleDrawerOpen(isOpen) {
  return {
    payload: { isOpen },
    type: SET_IS_SCHEDULE_DRAWER_OPEN,
  };
}

export function setIsSliderFocused({ form, value }) {
  return {
    payload: { form, value },
    type: SET_IS_SLIDER_FOCUSED,
  };
}

export function updateFormError({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: UPDATE_FORM_ERROR,
  };
}
